import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.333 3.25a5.083 5.083 0 1 0 0 10.166 5.083 5.083 0 0 0 0-10.166M1.75 8.333a6.583 6.583 0 1 1 13.166 0 6.583 6.583 0 0 1-13.166 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.97 11.97a.75.75 0 0 1 1.061 0l5 5a.75.75 0 0 1-1.06 1.061l-5-5a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }